// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4TXNT","closeBtn":"modal_closeBtn__2fYw0"};